import React from 'react';
import styled from 'styled-components';
import { Paper, Grid, Container } from '@material-ui/core';

const BlocWrapper = styled(({ height, ...otherProps }) => (
  <Paper {...otherProps} />
))`
  height: ${(props) => props.height};
  border-radius: 8px !important;
  box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.03), 0 0 24px 0 rgba(0, 0, 0, 0.08) !important;
`;

const FullHeightContainer = styled(Container)`
  height: 100%;
`;

const TitleFullHeightGrid = styled(Grid)`
  height: 100%;
  padding-bottom: 10px !important;
`;

const BodyWrapperGrid = styled(Grid)`
  margin-top: -56px !important;
`;

const HeaderWrapper = styled(({ backgroundImage, reverse, ...otherProps }) => (
  <div {...otherProps} />
))`
  && {
    height: 242px;
    &:before {
      content: '';
      height: 391px;
      background-image: url(${(props) => props.backgroundImage});
      background-repeat: no-repeat;
      background-position: 25%;
      background-color: black;
      background-size: cover;
      position: absolute;
      width: 100vw;
      z-index: -1000;
      top: 0px;
      left: 0px;
      transform: ${(props) => (props.reverse ? 'scaleX(-1)' : '')};
    }
  }
`;

export {
  BlocWrapper,
  FullHeightContainer,
  TitleFullHeightGrid,
  BodyWrapperGrid,
  HeaderWrapper,
};
